import { render, staticRenderFns } from "./RuleCustomEditProImport.vue?vue&type=template&id=411c536e&scoped=true"
import script from "./RuleCustomEditProImport.vue?vue&type=script&lang=js"
export * from "./RuleCustomEditProImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411c536e",
  null
  
)

export default component.exports